import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useResourceCalendarEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.EnableResourceCalendar, false);

  return Boolean(isEnabled);
}
